import React, { useEffect, useState } from "react";
import { Col, Row, Button, Image, Card } from "antd";
import { useNavigate } from "react-router";
import { useSelector } from "react-redux";
import { CAR, UPLOADS_URL } from "../../config/constants/api";
import DashbordSidebar from "../../components/DashboardSidebar";
import { Get } from "../../config/api/get";

function CreateAccount() {
  const [vehicleDetails, setVehicleDetails] = useState(null);
  const [stats, setStats] = useState(null);
  const [rates, setRates] = useState(null);
  const [selectedImage, setSelectedImage] = useState(null);
  const userToken = useSelector((state) => state.user.userToken);
  const navigate = useNavigate();
  
  const getDriverVehicle = () => {
    Get(CAR.getMyCar, userToken)
      .then((response) => {
        if (response.status && response?.data) {
          setVehicleDetails(response?.data?.car);
          setStats(response?.data?.stats);
          setRates(response?.data?.rates);
          if (response?.data?.car) {
            setSelectedImage(response?.data?.car?.image);
          }
        } else {
          navigate("/vehicleCreation");
        }
      })
      .catch((err) => {
        let message = err?.response?.data?.message;
        if (message === "Car Not Found") {
          navigate("/vehicleCreation");
        }
        console.log("Error fetching Profile Information ", err);
      });
  };
  
  useEffect(() => {
    getDriverVehicle();
    // eslint-disable-next-line
  }, []);

  return (
    <div className="shop-page">
      <Row style={{ width: "100%", justifyContent: "center" }}>
        <Col xs={23} md={21}>
          <div className="shop-page-main">
            <Row gutter={[16, 16]}>
              <Col xs={24} md={24} lg={24} xl={24}>
                <div className="my-account-profile">
                  <section className="side-menu-parent">
                    <DashbordSidebar />
                    {vehicleDetails && (
                      <div className="about-us-section">
                        <div className="bg-parent">
                          <h3 className="main-heading">My Car</h3>
                          
                          {/* Car Image with Thumbnails - Main on Left, Thumbnails on Right */}
                          <Row gutter={[24, 24]} style={{ marginBottom: 24 }}>
                            <Col xs={24} md={18}>
                              <Card
                                bordered={false}
                                style={{
                                  borderRadius: 12,
                                  boxShadow: "0 6px 18px rgba(15, 23, 42, 0.05)",
                                  overflow: "hidden",
                                }}
                                bodyStyle={{ padding: 0 }}
                              >
                                {(selectedImage || vehicleDetails?.image) && (
                                  <div style={{ 
                                    width: "100%", 
                                    height: "600px",
                                    overflow: "hidden",
                                    backgroundColor: "#f5f5f5",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center"
                                  }}>
                                    <Image
                                      src={UPLOADS_URL + (selectedImage || vehicleDetails.image)}
                                      alt="Car"
                                      preview={false}
                                      style={{
                                        width: "100%",
                                        height: "100%",
                                        objectFit: "cover",
                                        objectPosition: "center",
                                      }}
                                    />
                                  </div>
                                )}
                              </Card>
                            </Col>
                            {vehicleDetails?.gallery && vehicleDetails.gallery.length > 0 && (
                              <Col xs={24} md={6}>
                                <div style={{ 
                                  display: "flex",
                                  flexDirection: "column",
                                  gap: "12px",
                                  height: "600px",
                                  overflowY: "auto",
                                  overflowX: "hidden",
                                  paddingRight: "8px"
                                }}>
                                  {vehicleDetails.gallery.map((image, index) => {
                                    if (!image) return null;
                                    const isSelected = selectedImage === image;
                                    return (
                                      <div
                                        key={index}
                                        onClick={() => setSelectedImage(image)}
                                        style={{
                                          width: "100%",
                                          height: "120px",
                                          minHeight: "120px",
                                          borderRadius: "8px",
                                          overflow: "hidden",
                                          border: isSelected ? "3px solid #1890ff" : "2px solid #e5e7eb",
                                          cursor: "pointer",
                                          backgroundColor: "#f5f5f5",
                                          flexShrink: 0,
                                          transition: "all 0.2s ease",
                                          opacity: isSelected ? 1 : 0.8,
                                        }}
                                        onMouseEnter={(e) => {
                                          if (!isSelected) {
                                            e.currentTarget.style.opacity = "1";
                                            e.currentTarget.style.borderColor = "#1890ff";
                                          }
                                        }}
                                        onMouseLeave={(e) => {
                                          if (!isSelected) {
                                            e.currentTarget.style.opacity = "0.8";
                                            e.currentTarget.style.borderColor = "#e5e7eb";
                                          }
                                        }}
                                      >
                                        <Image
                                          src={UPLOADS_URL + image}
                                          alt={`Gallery ${index + 1}`}
                                          preview={false}
                                          style={{
                                            width: "100%",
                                            height: "100%",
                                            objectFit: "cover",
                                          }}
                                        />
                                      </div>
                                    );
                                  })}
                                  {/* Show main image as first thumbnail if it exists */}
                                  {vehicleDetails?.image && (
                                    <div
                                      onClick={() => setSelectedImage(vehicleDetails.image)}
                                      style={{
                                        width: "100%",
                                        height: "120px",
                                        minHeight: "120px",
                                        borderRadius: "8px",
                                        overflow: "hidden",
                                        border: selectedImage === vehicleDetails.image ? "3px solid #1890ff" : "2px solid #e5e7eb",
                                        cursor: "pointer",
                                        backgroundColor: "#f5f5f5",
                                        flexShrink: 0,
                                        transition: "all 0.2s ease",
                                        opacity: selectedImage === vehicleDetails.image ? 1 : 0.8,
                                      }}
                                      onMouseEnter={(e) => {
                                        if (selectedImage !== vehicleDetails.image) {
                                          e.currentTarget.style.opacity = "1";
                                          e.currentTarget.style.borderColor = "#1890ff";
                                        }
                                      }}
                                      onMouseLeave={(e) => {
                                        if (selectedImage !== vehicleDetails.image) {
                                          e.currentTarget.style.opacity = "0.8";
                                          e.currentTarget.style.borderColor = "#e5e7eb";
                                        }
                                      }}
                                    >
                                      <Image
                                        src={UPLOADS_URL + vehicleDetails.image}
                                        alt="Main Car"
                                        preview={false}
                                        style={{
                                          width: "100%",
                                          height: "100%",
                                          objectFit: "cover",
                                        }}
                                      />
                                    </div>
                                  )}
                                </div>
                              </Col>
                            )}
                          </Row>

                          {/* Car Details Card - Specifications Format */}
                          <Row gutter={[24, 24]} style={{ marginBottom: 24 }}>
                            <Col span={24}>
                              <Card
                                bordered={false}
                                style={{
                                  borderRadius: 12,
                                  boxShadow: "0 6px 18px rgba(15, 23, 42, 0.05)",
                                }}
                                bodyStyle={{ padding: 0 }}
                              >
                                <div style={{ padding: "24px" }}>
                                  <h3 style={{ 
                                    fontSize: "20px", 
                                    fontWeight: 600, 
                                    color: "#111827",
                                    marginBottom: "24px",
                                    margin: 0
                                  }}>
                                    Specifications
                                  </h3>
                                  
                                  <div style={{ width: "100%" }}>
                                    {/* Vehicle Type */}
                                    <div style={{ 
                                      display: "flex", 
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                      padding: "12px 16px",
                                      borderBottom: "1px solid #e5e7eb",
                                      backgroundColor: "#ffffff"
                                    }}>
                                      <span style={{ fontSize: "15px", fontWeight: 500, color: "#111827" }}>
                                        Vehicle Type
                                      </span>
                                      <span style={{ fontSize: "15px", color: "#111827" }}>
                                        {vehicleDetails?.serviceType || "-"}
                                      </span>
                                    </div>

                                    {/* Brand Name */}
                                    <div style={{ 
                                      display: "flex", 
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                      padding: "12px 16px",
                                      borderBottom: "1px solid #e5e7eb",
                                      backgroundColor: "#f9fafb"
                                    }}>
                                      <span style={{ fontSize: "15px", fontWeight: 500, color: "#111827" }}>
                                        Brand Name
                                      </span>
                                      <span style={{ fontSize: "15px", color: "#111827" }}>
                                        {vehicleDetails?.brand || "-"}
                                      </span>
                                    </div>

                                    {/* Car Name */}
                                    <div style={{ 
                                      display: "flex", 
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                      padding: "12px 16px",
                                      borderBottom: "1px solid #e5e7eb",
                                      backgroundColor: "#ffffff"
                                    }}>
                                      <span style={{ fontSize: "15px", fontWeight: 500, color: "#111827" }}>
                                        Car Name
                                      </span>
                                      <span style={{ fontSize: "15px", color: "#111827" }}>
                                        {vehicleDetails?.name || "-"}
                                      </span>
                                    </div>

                                    {/* Car Model */}
                                    <div style={{ 
                                      display: "flex", 
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                      padding: "12px 16px",
                                      borderBottom: "1px solid #e5e7eb",
                                      backgroundColor: "#f9fafb"
                                    }}>
                                      <span style={{ fontSize: "15px", fontWeight: 500, color: "#111827" }}>
                                        Car Model
                                      </span>
                                      <span style={{ fontSize: "15px", color: "#111827" }}>
                                        {vehicleDetails?.model || "-"}
                                      </span>
                                    </div>

                                    {/* Car Number */}
                                    <div style={{ 
                                      display: "flex", 
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                      padding: "12px 16px",
                                      borderBottom: "1px solid #e5e7eb",
                                      backgroundColor: "#ffffff"
                                    }}>
                                      <span style={{ fontSize: "15px", fontWeight: 500, color: "#111827" }}>
                                        Car Number
                                      </span>
                                      <span style={{ fontSize: "15px", color: "#111827" }}>
                                        {vehicleDetails?.carNumber || "-"}
                                      </span>
                                    </div>

                                    {/* Passenger Capacity */}
                                    <div style={{ 
                                      display: "flex", 
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                      padding: "12px 16px",
                                      borderBottom: "1px solid #e5e7eb",
                                      backgroundColor: "#f9fafb"
                                    }}>
                                      <span style={{ fontSize: "15px", fontWeight: 500, color: "#111827" }}>
                                        Seating Capacity
                                      </span>
                                      <span style={{ fontSize: "15px", color: "#111827" }}>
                                        {vehicleDetails?.passengerCapacity ? `${vehicleDetails.passengerCapacity} Seater` : "-"}
                                      </span>
                                    </div>

                                    {/* Status */}
                                    <div style={{ 
                                      display: "flex", 
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                      padding: "12px 16px",
                                      borderBottom: vehicleDetails?.rejectionReason ? "1px solid #e5e7eb" : "none",
                                      backgroundColor: "#ffffff"
                                    }}>
                                      <span style={{ fontSize: "15px", fontWeight: 500, color: "#111827" }}>
                                        Status
                                      </span>
                                      <span style={{ fontSize: "15px", color: "#111827" }}>
                                        {vehicleDetails?.status || "-"}
                                      </span>
                                    </div>

                                    {/* Rejection Reason */}
                                    {vehicleDetails?.rejectionReason && (
                                      <div style={{ 
                                        display: "flex", 
                                        justifyContent: "space-between",
                                        alignItems: "flex-start",
                                        padding: "12px 16px",
                                        borderBottom: "1px solid #e5e7eb",
                                        backgroundColor: "#ffffff"
                                      }}>
                                        <span style={{ fontSize: "15px", fontWeight: 500, color: "#111827" }}>
                                          Rejection Reason
                                        </span>
                                        <span style={{ 
                                          fontSize: "15px", 
                                          color: "#dc2626",
                                          textAlign: "right",
                                          maxWidth: "60%"
                                        }}>
                                          {vehicleDetails.rejectionReason}
                                        </span>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </Card>
                            </Col>
                          </Row>

                          {/* Stats and Rates in a Row */}
                          <Row gutter={[24, 24]} style={{ marginBottom: 24 }}>
                            {/* Statistics Card */}
                            {stats && (
                              <Col xs={24} lg={12}>
                                <Card
                                  bordered={false}
                                  title={
                                    <span style={{ fontSize: 16, fontWeight: 600, color: "#111827" }}>
                                      Statistics
                                    </span>
                                  }
                                  style={{
                                    borderRadius: 12,
                                    boxShadow: "0 6px 18px rgba(15, 23, 42, 0.05)",
                                    height: "100%",
                                  }}
                                  headStyle={{ borderBottom: "1px solid #f3f4f6" }}
                                >
                                  <Row gutter={[16, 16]}>
                                    <Col xs={24} sm={8}>
                                      <div style={{ 
                                        padding: "20px", 
                                        backgroundColor: "#f9fafb", 
                                        borderRadius: "8px",
                                        textAlign: "center"
                                      }}>
                                        <div style={{ fontSize: "28px", fontWeight: 600, color: "#111827" }}>
                                          {stats?.totalTrips || 0}
                                        </div>
                                        <div style={{ fontSize: "13px", color: "#6b7280", marginTop: "8px" }}>
                                          Total Trips
                                        </div>
                                      </div>
                                    </Col>
                                    <Col xs={24} sm={8}>
                                      <div style={{ 
                                        padding: "20px", 
                                        backgroundColor: "#f9fafb", 
                                        borderRadius: "8px",
                                        textAlign: "center"
                                      }}>
                                        <div style={{ fontSize: "28px", fontWeight: 600, color: "#111827" }}>
                                          {stats?.averageRating ? `${stats.averageRating.toFixed(1)} ⭐` : "0 ⭐"}
                                        </div>
                                        <div style={{ fontSize: "13px", color: "#6b7280", marginTop: "8px" }}>
                                          Average Rating
                                        </div>
                                      </div>
                                    </Col>
                                    <Col xs={24} sm={8}>
                                      <div style={{ 
                                        padding: "20px", 
                                        backgroundColor: "#f9fafb", 
                                        borderRadius: "8px",
                                        textAlign: "center"
                                      }}>
                                        <div style={{ fontSize: "28px", fontWeight: 600, color: "#111827" }}>
                                          {stats?.monthsActive || 0}
                                        </div>
                                        <div style={{ fontSize: "13px", color: "#6b7280", marginTop: "8px" }}>
                                          Months Active
                                        </div>
                                      </div>
                                    </Col>
                                  </Row>
                                </Card>
                              </Col>
                            )}

                            {/* Rates Card */}
                            {rates && (
                              <Col xs={24} lg={12}>
                                <Card
                                  bordered={false}
                                  title={
                                    <span style={{ fontSize: 16, fontWeight: 600, color: "#111827" }}>
                                      Rates
                                    </span>
                                  }
                                  style={{
                                    borderRadius: 12,
                                    boxShadow: "0 6px 18px rgba(15, 23, 42, 0.05)",
                                    height: "100%",
                                  }}
                                  headStyle={{ borderBottom: "1px solid #f3f4f6" }}
                                >
                                  <Row gutter={[16, 16]}>
                                    {rates?.bookByHour ? (
                                      <Col xs={24}>
                                        <div style={{ 
                                          padding: "20px", 
                                          backgroundColor: "#f9fafb", 
                                          borderRadius: "8px"
                                        }}>
                                          <div style={{ fontSize: "14px", fontWeight: 500, color: "#6b7280", marginBottom: "8px" }}>
                                            Book By Hour
                                          </div>
                                          <div style={{ fontSize: "24px", fontWeight: 600, color: "#111827" }}>
                                            ${rates.bookByHour.hourlyRate || 0} <span style={{ fontSize: "16px", fontWeight: 400, color: "#6b7280" }}>/ hour</span>
                                          </div>
                                        </div>
                                      </Col>
                                    ) : null}
                                    {rates?.bookByDistance ? (
                                      <Col xs={24}>
                                        <div style={{ 
                                          padding: "20px", 
                                          backgroundColor: "#f9fafb", 
                                          borderRadius: "8px"
                                        }}>
                                          <div style={{ fontSize: "14px", fontWeight: 500, color: "#6b7280", marginBottom: "8px" }}>
                                            Book By Distance
                                          </div>
                                          <div style={{ fontSize: "24px", fontWeight: 600, color: "#111827" }}>
                                            ${rates.bookByDistance.perMileRate || 0} <span style={{ fontSize: "16px", fontWeight: 400, color: "#6b7280" }}>/ mile</span>
                                          </div>
                                        </div>
                                      </Col>
                                    ) : null}
                                    {!rates?.bookByHour && !rates?.bookByDistance && (
                                      <Col span={24}>
                                        <div style={{ 
                                          padding: "20px", 
                                          backgroundColor: "#f9fafb", 
                                          borderRadius: "8px",
                                          textAlign: "center",
                                          color: "#6b7280"
                                        }}>
                                          No rates configured
                                        </div>
                                      </Col>
                                    )}
                                  </Row>
                                </Card>
                              </Col>
                            )}
                          </Row>

                          {/* Edit Button */}
                          <Row>
                            <Col span={24}>
                              <div style={{ textAlign: "center", marginTop: "10px" }}>
                                <Button
                                  type=""
                                  htmlType="submit"
                                  className="btn web-btn px-5"
                                  onClick={() =>
                                    navigate("/vehicleEdit", {
                                      state: { vehicleDetails },
                                    })
                                  }
                                >
                                  Edit Car Details
                                </Button>
                              </div>
                            </Col>
                          </Row>
                        </div>
                      </div>
                    )}
                  </section>
                </div>
              </Col>
            </Row>
          </div>
        </Col>
      </Row>
    </div>
  );
}

export default CreateAccount;
